"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createMarker = void 0;
var _uiTheme = require("@kyruus/ui-theme");
var _MarkerWrapper = require("./MarkerWrapper");
/**
 * Creates HTML content for Advanced Marker with pin element and optional label
 * @private
 */
const createAdvancedMarkerContent = _ref => {
  let {
    gMaps,
    theme,
    label
  } = _ref;
  const container = document.createElement('div');
  container.className = 'advanced-marker-container';
  container.style.cssText = `
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
  const pinElement = new gMaps.marker.PinElement({
    background: (0, _uiTheme.fromTheme)('color_providermatch')({
      theme
    }),
    borderColor: 'white',
    glyphColor: 'white'
  });
  container.appendChild(pinElement.element);
  if (label?.text) {
    const labelEl = document.createElement('div');
    labelEl.textContent = label.text;
    labelEl.style.cssText = `
      position: absolute;
      color: white;
      font-weight: bold;
      font-size: 14px;
      pointer-events: none;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
    `;
    container.appendChild(labelEl);
  }
  return container;
};

/**
 * Factory function that creates appropriate marker type based on feature flag.
 * Returns MarkerWrapper that provides transparent backward compatibility.
 *
 * @param {Object} options - Configuration options
 * @param {google.maps} options.gMaps - Google Maps API object
 * @param {google.maps.Map} options.map - Map instance
 * @param {Object} options.position - Marker position {lat, lng}
 * @param {string} options.title - Marker title
 * @param {Object} [options.label] - Label configuration {text, color}
 * @param {Object} options.theme - Theme object for styling
 * @param {boolean} [options.useAdvancedMarkers=false] - Enable Advanced Markers API
 * @returns {MarkerWrapper} Wrapped marker with unified interface
 */
const createMarker = _ref2 => {
  let {
    gMaps,
    map,
    position,
    title,
    label = null,
    theme,
    useAdvancedMarkers = false
  } = _ref2;
  const shouldUseAdvanced = useAdvancedMarkers && gMaps.marker?.AdvancedMarkerElement;
  if (shouldUseAdvanced) {
    const content = createAdvancedMarkerContent({
      gMaps,
      theme,
      label
    });
    const advancedMarker = new gMaps.marker.AdvancedMarkerElement({
      map,
      position,
      title,
      content,
      gmpClickable: true
    });
    return new _MarkerWrapper.MarkerWrapper(advancedMarker, 'advanced');
  }

  // Legacy marker (default)
  const legacyMarker = new gMaps.Marker({
    map,
    position,
    title,
    label
  });
  return legacyMarker;
};
exports.createMarker = createMarker;